<template>
  <v-card flat class="pa-0 d-flex" color="bg_dark">
    <side-nav />
    <scenario-builder ref="scenarioBuilder" />
    <v-row>
      <v-col
        cols="11"
        offset="1"
        sm="10"
        offset-sm="1"
        xl="8"
        offset-xl="2">
        <api-error-alert class="mx-12 mt-3 mb-0" />
        <auth-error-alert class="mx-12 mt-3 mb-0" />
        <router-view></router-view>
      </v-col>
    </v-row>
    <v-btn
      fixed
      text
      fab
      top
      right
      color="dw_green"
      small
      @click="showScenarioBuilder(true)"
      :style="rightPlacement"
      title="Scenario Builder"
    >
      <v-icon v-text="mdiBullseyeArrow" />
    </v-btn>
  </v-card>
</template>

<script>
import { mapMutations } from 'vuex';
import { mdiBullseyeArrow } from '@mdi/js';
import apiErrorAlert from '@/components/notifications/apiErrorAlert.vue';
import authErrorAlert from '@/components/notifications/authErrorAlert.vue';
import sideNav from '@/components/playbook/sideNav.vue';
import scenarioBuilder from '@/components/playbook/scenarioBuilder/scenarioBuilder.vue';

export default {
  name: 'playbook',
  components: {
    apiErrorAlert,
    authErrorAlert,
    sideNav,
    scenarioBuilder
  },
  data() {
    return {
      mdiBullseyeArrow,
      rightPlacement: 'top: 60px; right: 96px;'
    };
  },
  watch: {
    '$vuetify.breakpoint.name': {
      handler(name) {
        if (name === 'xs' || name === 'sm') {
          this.rightPlacement = 'top: 60px; right: 24px;';
        } else if (name === 'md') {
          this.rightPlacement = 'top: 60px; right: 48px;';
        } else {
          this.rightPlacement = 'top: 60px; right: 96px;';
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations([
      'showScenarioBuilder'
    ])
  }
};
</script>
